import { MenuItemType } from '../types';

export const coreMenuItem = (menuItem: MenuItemType) => {
  const { pathname, origin, hash } = window.location;

  const isHomeURL =
    window.location.pathname === '/fo' || window.location.pathname === '/';

  // first condition: if is active fov1 route
  // second condition: if is active home route
  const isExternalRouteActive = `/${hash}` === menuItem.externalRoute;

  const isReactRouteActive =
    pathname === `/fo${menuItem.reactRoute}` ||
    pathname === `/store${menuItem.reactRoute}` ||
    (isHomeURL && menuItem.reactRoute === `${origin}/`);

  return {
    isExternalRouteActive,
    isReactRouteActive,
  };
};
